import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { OnboardingWrapper, OnboardingAnim, OnboardingGridItem, } from './OnboardingBackground.style';
const calculateNumCells = () => {
    const cellSize = 55;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const numColumns = Math.floor(windowWidth / cellSize);
    const numRows = Math.floor(windowHeight / cellSize);
    return { numColumns, numRows };
};
const OnboardingBackground = () => {
    const [cellIndex, setCellIndex] = useState(-1);
    const { numColumns, numRows } = calculateNumCells();
    const blinkInterval = useRef(null);
    useEffect(() => {
        const blinkRandomCell = () => {
            const randomIndex = Math.floor(Math.random() * numColumns * numRows);
            setCellIndex(randomIndex);
        };
        blinkRandomCell();
        blinkInterval.current = setInterval(blinkRandomCell, 2000);
        return () => {
            if (blinkInterval.current)
                clearInterval(blinkInterval.current);
        };
    }, [numColumns, numRows]);
    return (_jsx(OnboardingWrapper, { children: _jsx(OnboardingAnim, { style: {
                gridTemplateColumns: `repeat(${numColumns}, 55px)`,
                gridTemplateRows: `repeat(${numRows}, 55px)`,
            }, children: _jsx(OnboardingGridItem, { style: {
                    gridColumn: (cellIndex % numColumns) + 1,
                    gridRow: Math.floor(cellIndex / numColumns) + 1,
                } }) }) }));
};
export default OnboardingBackground;
